<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'font-size-tracker',
    data () {
      return {
        height: 0
      }
    },
    methods: {
      checkSize () {
        if (this.heigth !== this.$el.offsetHeight && this.$el.offsetHeight > 10) {
          this.heigth = this.$el.offsetHeight
          this.$el.style.fontSize = this.$el.offsetHeight + 'px'
        }
      }
    },
    mounted () {
      this.checkSize()
      this.resizeCheck = setInterval(this.checkSize, 500)
    },
    beforeDestroy () {
      clearInterval(this.resizeCheck)
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FontSizeTracker.vue?68ddb589